import React from 'react'

import "./description-comment-tag.css"

const DescriptonCommentTag = (props) => {

    const { message } = props
    return (
        <React.Fragment>
            <p className="description-comment-tag">
                {/* <Icon type="file" style={{ "fontSize": "18px", "color": "#FAFAFA" }} /> */}
                {message}
            </p>

        </React.Fragment>
    )
}



export default DescriptonCommentTag